<template>
  <div class="container">
    <section class="advantage" data-aos="fade-down">
      <div class="advantage__item">
        <img src="@/assets/img/advantage-1.svg" alt="" class="advantage__img">
        <h2 class="advantage__title">{{ $t("main.advantage.title-1") }}</h2>
        <p class="advantage__text">{{ $t("main.advantage.text-1") }}</p>
      </div>
      <div class="advantage__item">
        <img src="@/assets/img/advantage-2.svg" alt="" class="advantage__img">
        <h2 class="advantage__title">{{ $t("main.advantage.title-2") }}</h2>
        <p class="advantage__text">{{ $t("main.advantage.text-2") }}</p>
      </div>
      <div class="advantage__item">
        <img src="@/assets/img/advantage-3.svg" alt="" class="advantage__img">
        <h2 class="advantage__title">{{ $t("main.advantage.title-3") }}</h2>
        <p class="advantage__text">{{ $t("main.advantage.text-3") }}</p>
      </div>
      <div class="advantage__item">
        <img src="@/assets/img/advantage-4.svg" alt="" class="advantage__img">
        <h2 class="advantage__title">{{ $t("main.advantage.title-4") }}</h2>
        <p class="advantage__text">{{ $t("main.advantage.text-4") }}</p>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
</style>